"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    buttonAbsolute: {
      width: 48,
      height: 48,
      position: 'absolute',
      right: 0,
      bottom: 45
    },
    button: {
      width: 48,
      height: 48,
      position: 'absolute',
      right: 0
    }
  };
});

var RemoveContactCell = function RemoveContactCell(_ref) {
  var isAbsolute = _ref.isAbsolute,
      rowIndex = _ref.rowIndex,
      rowData = _ref.rowData,
      onRemove = _ref.onRemove,
      columnData = _ref.columnData;
  var classes = useStyles();
  var handleRemoveContact = (0, _react.useCallback)(function () {
    onRemove(rowIndex, rowData);
  }, [rowData, rowIndex, onRemove]);
  var isDisabled = (columnData === null || columnData === void 0 ? void 0 : columnData.isLoading) || (columnData === null || columnData === void 0 ? void 0 : columnData.isOneContactLeft);
  return rowData !== null && rowData !== void 0 && rowData.id ? /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    className: isAbsolute ? classes.buttonAbsolute : classes.button,
    "data-testid": "GiftingFlow.RemoveContact.Button-".concat(rowIndex),
    disabled: isDisabled,
    onClick: handleRemoveContact
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    fontSize: "20px",
    color: isDisabled ? 'grey.main' : 'link.main',
    icon: "times"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var _default = /*#__PURE__*/(0, _react.memo)(RemoveContactCell);

exports.default = _default;